import { makeStyles } from 'tss-react/mui';

const iconSize = 20;

export default makeStyles()((theme) => ({
  root: {
    marginRight: theme.spacing(2),
  },
  statusText: {
    color: theme.palette.text.secondary,
  },
  pendingIcon: {
    color: theme.palette.submissionStatuses.review,
    fontSize: iconSize,
  },
  approvedIcon: {
    color: theme.palette.submissionStatuses.approved,
    fontSize: iconSize,
  },
  rejectedIcon: {
    color: theme.palette.submissionStatuses.rejected,
    fontSize: iconSize,
  },
  flaggedIcon: {
    color: theme.palette.submissionStatuses.flagged,
    fontSize: iconSize,
  },
}));
